<div class="horizontal-wrap align-items-start">
  <div class="pe-2 me-auto">
    <ng-content select="h2,h3,h4,h5,nav"></ng-content>
  </div>
  <div class="horizontal-wrap justify-content-end ml-auto">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
<ng-content></ng-content>
